export default "__VITE_ASSET__CBbca5ie__"